<template>
  <div class="global-popup-bg" title="Bienvenue" v-if="active">
    <div class="global-popup shadow-xl">
      <div class="global-popup-header py-4 px-6 text-gray-500 bg-grey-light bg-opacity-50">Bienvenue !</div>
      <div class="p-6">
        <!-- <h3 class="font-medium mb-6">Bonjour, et bienvenue dans l'application CFC Dashboard !</h3> -->
        <div class="text-lg">
          <div class="flex items-center mb-4">
            <div class="bg-info rounded-full w-16 h-16 p-4 mr-6"><feather-icon icon="BellIcon" :svgClasses="[`text-white`, 'stroke-current h-8 w-8']"></feather-icon></div>
            <p>Avant de continuer, veuillez prendre connaissance de nos <strong>conditions générales de vente</strong>, de la <strong>convention d'assistance</strong>, ainsi que de nos <strong>conditions tarifaires</strong> ci-dessous:</p>
          </div>
          <div class="pl-16 py-4 m-4">
            <legal-links icons class="py-0 font-medium text-lg" />
          </div>

            <p class="pl-16 text-base text-danger m-4">
              <i class="fal fa-info-circle mr-2" />Vous devez télécharger ces documents pour accéder à l'application.
            </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LegalLinks from '@/components/LegalLinks.vue'
import { mapState } from 'vuex'

export default {
  name: 'LegalsPopup',
  components: { 
    LegalLinks
  },
  computed: {
    ...mapState({
      activeUser: state => state.user.activeUser
    }),
    active () { 
      if (this.activeUser) {
        const legals = this.activeUser.legals
        return legals ? legals.convention || legals.cgv || legals.tarifs : false
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.global-popup {
  width: 768px;
  @media (max-width: 768px){
    width: 90vw;
  }
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999999;
  transition: all .25s ease;
  &-bg {
    width: 100%;
    background: rgba(0,0,0,.4);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    z-index: 999998;
    transition: all .25s ease;
    backdrop-filter: blur(7px);
  }
}
</style>